import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExternalLink = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.231 5h-2.98C4.638 5 3 6.85 3 9.468v7.064C3 19.15 4.63 21 7.25 21h7.498C17.368 21 19 19.15 19 16.532v-2.547M21 8.132V3m0 0h-5.132M21 3l-8 8"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgExternalLink);
export default ForwardRef;
